import React, { useState } from "react";
import Edit_Non_Work from "./edit_Non_Work/Edit_Non_Work";
import Non_Work_Form from "./non_Work_Form/Non_Work_Form";
import Non_Work_table from "./non_Work_table/Non_Work_table";
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";

function Non_Work() {
  const [isEdit, setIsEdit] = useState(false);

  return (
    <section className="Imperiality">
      {isEdit ? (
        <>
          <div className="back_div">
            <Common_Back_Btn backText="Edit Non- Confirming Work" />
          </div>
          <Edit_Non_Work onCancel={() => setIsEdit(false)} />
        </>
      ) : (
        <>
          <div className="back_div">
            <Common_Back_Btn backText="Non- Confirming Work" />
          </div>

          <div className="imperiality_Form_div">
            <Non_Work_Form />
          </div>

          <div className="imperiality_table_div">
            <Non_Work_table onEdit={() => setIsEdit(true)} />
          </div>
        </>
      )}
    </section>
  );
}

export default Non_Work;
